import React from "react";

const FederalImmigrationCap = () => {
  return (
    <div>
      <div className="single mt-125">
        <div className="container" style={{ marginTop: "20px" }}>
          <div className="section-header">
            <h2>Federal Immigration Caps Raise Alarms</h2>
            <h3>
              Poilievre and Carney talk tough on the trail—while provinces brace
              for serious fallout
            </h3>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="details-image">
                <img
                  src="img/Blogs/Federal Immigration Caps Raise Alarms.png"
                  alt="ederal Immigration Caps Raise Alarms"
                  style={{
                    marginTop: "30px",
                    maxHeight: "400px",
                    maxWidth: "80%",
                  }}
                />
              </div>
              <div className="details-text">
                <h2>Two Leaders, Same Direction on Immigration Caps</h2>
                <p>
                  Pierre Poilievre and Mark Carney appear to be approaching
                  immigration differently on the campaign trail—but beneath the
                  rhetoric, both are backing a continued slowdown in immigration
                  levels, including cuts to temporary foreign workers and
                  international students.
                </p>
                <p>
                  While Poilievre uses immigration as a key message—blaming
                  rapid population growth for housing and affordability
                  crises—Carney has mostly avoided the topic. Still, both
                  leaders agree: immigration must remain capped until
                  infrastructure catches up.
                </p>

                <hr />

                <h2>The Policy Shift: From Growth to Freeze</h2>
                <p>
                  Prime Minister Justin Trudeau’s government set the tone last
                  fall with a major policy change:
                </p>
                <ul>
                  <li>
                    Permanent residents will drop from 485,000 in 2024 to
                    395,000 in 2025, falling further to 365,000 by 2027.
                  </li>
                  <li>
                    Caps also apply to temporary foreign workers and
                    international students.
                  </li>
                  <li>
                    The goal: near-zero population growth for at least the next
                    three years.
                  </li>
                </ul>
                <p>
                  This marks a dramatic shift from Canada’s post-pandemic
                  strategy of using immigration to spur economic growth and
                  avoid recession.
                </p>
                <p>
                  “We didn’t get the balance quite right,” Trudeau admitted,
                  referencing the pressures on housing and services.
                </p>

                <hr />

                <h2>Poilievre: Tie Immigration to Housing & Services</h2>
                <p>
                  Poilievre has directly linked Canada's housing crisis to
                  immigration policies. He promises to:
                </p>
                <ul>
                  <li>
                    Scrap the Century Initiative, which aims for a population of
                    100 million by 2100.
                  </li>
                  <li>
                    Cap immigration so that it never grows faster than the rate
                    of housing, healthcare, or job creation.
                  </li>
                  <li>
                    Restore the Temporary Foreign Worker Program for essential
                    sectors only—excluding regions with unemployment above 6%.
                  </li>
                  <li>
                    Tighten oversight of the international student system,
                    ensuring entrants have real admission letters, housing, and
                    financial backing.
                  </li>
                </ul>
                <p>
                  “We had the best immigration system in the world before the
                  Liberals,” he told supporters in Fredericton.
                </p>

                <hr />

                <h2>Carney: Maintain Caps Until “Capacity Is Built”</h2>
                <p>
                  Though softer in tone, Carney has echoed Poilievre’s calls to
                  hold immigration levels steady.
                </p>
                <p>
                  “We haven’t lived up to our promise to those we brought to
                  this country,” he said, pointing to issues with housing,
                  education, and services.
                </p>
                <p>Carney has acknowledged:</p>
                <ul>
                  <li>
                    Caps on international students and foreign workers should
                    remain in place until Canada’s capacity improves.
                  </li>
                  <li>
                    There must be closer collaboration between federal and
                    provincial governments on the immigration file.
                  </li>
                </ul>

                <hr />

                <h2>Atlantic Canada: Collateral Damage from Federal Caps</h2>
                <p>
                  In New Brunswick, where foreign workers and international
                  students are vital to keeping the economy running, the federal
                  caps are causing deep concern.
                </p>
                <p>
                  <strong>Key Stats:</strong>
                </p>
                <ul>
                  <li>
                    130,000 job vacancies projected in NB over the next several
                    years due to retirements and economic growth.
                  </li>
                  <li>
                    40% of students at NBCC are international, paying over
                    $9,000/year in tuition—compared to $3,500 for domestic
                    students.
                  </li>
                  <li>
                    New Brunswick’s economic immigration spots have been slashed
                    by 50%, from 5,500 to 2,750 for 2025.
                  </li>
                </ul>

                <hr />

                <h2>Economists Warn: This Could Cripple New Brunswick</h2>
                <p>
                  Economists David Campbell and Richard Saillant have strongly
                  criticized both parties for ignoring regional realities:
                </p>
                <p>
                  “It doesn’t make sense to send skilled foreign workers home
                  because their permits expired while waiting for permanent
                  residency,” said Campbell.
                </p>
                <p>
                  “Capping immigration nationally won’t increase
                  productivity—it’ll just create a labour tug-of-war between
                  provinces.”
                </p>
                <p>
                  Saillant warns that New Brunswick’s economic and political
                  landscape will be dramatically altered by lower population
                  growth, slower revenues, and shrinking fiscal flexibility.
                </p>

                <hr />

                <h2>
                  Colleges Under Threat: Losing Programs, Funding, and Students
                </h2>
                <p>NBCC and CCNB have already raised red flags:</p>
                <ul>
                  <li>
                    NBCC is requesting an additional $4 million per year from
                    the province just to stay afloat after student cuts.
                  </li>
                  <li>
                    CCNB’s Bathurst campus reports that 22 out of 35 programs
                    rely on international students for viability.
                  </li>
                </ul>
                <p>
                  “Without international students, we couldn’t afford to offer
                  these programs,” said CCNB President Pierre Zundel.
                </p>

                <hr />

                <h2>Critical Jobs Left Off the Priority List</h2>
                <p>
                  In response to fewer federal PR nominations, the provincial
                  governments of Canada will exclude workers in food services,
                  seafood processing, and other key sectors from the 2025
                  selection process—despite these industries being major
                  employers. This was never the case before in recent history.
                </p>
                <p>
                  Instead, provinces will prioritize healthcare, education, and
                  skilled trades, leaving other major service sectors with
                  limited options to find workforce.
                </p>

                <hr />

                <h2>
                  🗳️ Election Day is Near: Canadians Must Ask Tough Questions
                </h2>
                <p>
                  With less than 10 business days to go until Election Day on
                  April 28, voters in Canada face a critical choice.
                </p>
                <p>
                  Both major federal parties appear committed to maintaining
                  hard immigration caps for the foreseeable future—caps that
                  risk undermining the province’s economy, shrinking its labour
                  pool, and threatening critical infrastructure.
                </p>
                <p>
                  If major employment sectors like Hospitality, Tourism, Food,
                  Manufacturing, and Retail are unable to find long-term
                  employees, that would directly impact Canadian GDP and
                  inflation and may hugely shrink the economy; hopefully we
                  won't head to the recession this year but all the cards are
                  still on table. The stakes are higher this election time.
                </p>
                <p>
                  ✅ Check your voter registration, know your candidates, and
                  show up to vote.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FederalImmigrationCap;
